// 🛡️ Project: LearningPortal
// 📅 Created: 2025
// 👤 Author: Dmitriy P.A.
// 🔒 Proprietary Code – do not copy without permission.

import React from "react";
import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import Underline from "@tiptap/extension-underline";
import Strike from "@tiptap/extension-strike";
import Highlight from "@tiptap/extension-highlight";
import Mention from "@tiptap/extension-mention";
import TextStyle from "@tiptap/extension-text-style";

const FontSize = TextStyle.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      fontSize: {
        default: null,
        parseHTML: (element) => element.style.fontSize?.replace(/['\"]+/g, ""),
        renderHTML: (attributes) => {
          if (!attributes.fontSize) return {};
          return { style: `font-size: ${attributes.fontSize}` };
        },
      },
    };
  },
});

const DescriptionRenderer = ({ content }) => {
  const editor = useEditor({
    editable: false,
    extensions: [
      StarterKit,
      Underline,
      Strike,
      Highlight,
      Mention.configure({
        HTMLAttributes: { class: "mention" },
      }),
      TextStyle,
      FontSize,
    ],
    content,
  });

  if (!editor) return null;

  return <EditorContent editor={editor} />;
};

export default DescriptionRenderer;
